import React from 'react';
import Subcontent from '../Subcontent/Subcontent';
import './Left.css';

function Left() {
    return (
        <>
           <div className="left_top">
               <div className="content_heading">
                   Content
               </div>
               <Subcontent unit="1" unit_name="Course Introduction"/>
               <Subcontent unit="2" unit_name="Vedic Lecture"/>
               <Subcontent unit="3" unit_name="Techniques in Vedic"/>
               <Subcontent unit="3" unit_name="Techniques in Vedic"/>
               
           </div> 
        </>
    )
}

export default Left
